function createSourceElement(image, mediaQuery) {
  return image ? `
    <source 
      media="${mediaQuery}"
      srcset="${image}" 
    />` : '';
}

function createImgElement(image, altText) {
  return image ? `
    <img 
      src="${image}"
      loading="lazy"
      alt="${altText}" 
    />` : '';
}

/**
 * Generate a picture element with the given content
 * @param {HTMLElement} content - The content element must have the following attributes:
 * - image-desktop (compulsory): The image that will be shown on desktop devices in the corresponding panel.
 * - image-tablet (optional): The image that will be shown on tablet devices in the corresponding panel.
 * - image-mobile (optional): The image that will be shown on mobile devices in the corresponding panel. 
 * @param {string} args.customClass - Custom class for the picture element.
 * @param {string} args.customStyle - Custom style for the picture element.
 * @returns {string}
 */
export function getPicture(content, {
  customClass = '',
  customStyle = '',
} = {}) {
  const imgAttributes = {
    desktop: content.getAttribute("image-desktop"),
    tablet: content.getAttribute("image-tablet"),
    mobile: content.getAttribute("image-mobile"),
    alt: content.getAttribute("image-alt") || "",
  };

  const desktopSource = createSourceElement(imgAttributes.desktop, "(min-width: 992px)");
  const tabletSource = createSourceElement(imgAttributes.tablet, "(min-width: 768px) and (max-width: 991px)");
  const mobileSource = createSourceElement(imgAttributes.mobile, "(max-width: 767px)");
  const imgElement = createImgElement(imgAttributes.desktop, imgAttributes.alt);

  if(
    !imgAttributes.desktop && 
    !imgAttributes.tablet && 
    !imgAttributes.mobile
  ) {
    return '';
  } 
  else if (
    imgAttributes.desktop && 
    !imgAttributes.tablet && 
    !imgAttributes.mobile
  ) {
    return `
      <picture 
        style="${customStyle}"
        class="${customClass}"
      >
        ${imgElement}
      </picture>`;
  }
  else if (
    imgAttributes.desktop && 
    !imgAttributes.tablet && 
    imgAttributes.mobile
  ) {
    return `
      <picture 
        style="${customStyle}"
        class="${customClass}"
      >
        ${desktopSource}
        ${createSourceElement(imgAttributes.mobile, "(max-width: 991px)")}
        ${imgElement}
      </picture>`;
  }
  else {
    return `
      <picture 
        style="${customStyle}"
        class="${customClass}"
      >
        ${desktopSource}
        ${tabletSource}
        ${mobileSource}
        ${imgElement}
      </picture>`;
  }
}